import { Injectable } from '@angular/core';

import { Contract } from '../model/contract';

import { ugovor_o_radu_neodredjeno_osnovno } from '../contracts/1_ugovor_o_radu_neodredjeno_osnovno';
import { ugovor_o_radu_neodredjeno_osnovno_1 } from '../contracts/1.1_ugovor_o_radu_neodredjeno_osnovno.1';
import { ugovor_o_radu_neodredjeno_dodatno } from '../contracts/2_ugovor_o_radu_neodredjeno_dodatno';
import { ugovor_o_radu_neodredjeno_dodatno_1 } from '../contracts/2.1_ugovor_o_radu_neodredjeno_dodatno.1';
import { ugovor_o_radu_odredjeno_osnovno } from '../contracts/3_ugovor_o_radu_odredjeno_osnovno';
import { ugovor_o_radu_odredjeno_osnovno_1 } from '../contracts/3.1_ugovor_o_radu_odredjeno_osnovno.1';
import { ugovor_o_radu_odredjeno_dodatno } from '../contracts/4_ugovor_o_radu_odredjeno_dodatno';
import { ugovor_o_radu_odredjeno_dodatno_1 } from '../contracts/4.1_ugovor_o_radu_odredjeno_dodatno.1';
import { aneks_ugovora_o_radu } from '../contracts/5_aneks_ugovora_o_radu';
import { aneks_ugovora_o_radu_1 } from '../contracts/5.1_aneks_ugovora_o_radu.1';
import { otkaz_ugovora_o_radu_na_zahtjev_radnika_bez_otkaznog_roka } from '../contracts/6_otkaz_ugovora_o_radu_na_zahtjev_radnika_bez_otkaznog_roka';
import { otkaz_ugovora_o_radu_na_zahtjev_radnika_bez_otkaznog_roka_1 } from '../contracts/6.1_otkaz_ugovora_o_radu_na_zahtjev_radnika_bez_otkaznog_roka.1';
import { otkaz_ugovora_o_radu_na_zahtjev_radnika } from '../contracts/7_otkaz_ugovora_o_radu_na_zahtjev_radnika';
import { otkaz_ugovora_o_radu_na_zahtjev_radnika_1 } from '../contracts/7.1_otkaz_ugovora_o_radu_na_zahtjev_radnika.1';
import { poslovno_uvjetovani_otkaz_gospodarski } from '../contracts/8_poslovno_uvjetovani_otkaz_gospodarski';
import { poslovno_uvjetovani_otkaz_gospodarski_1 } from '../contracts/8.1_poslovno_uvjetovani_otkaz_gospodarski.1';
import { poslovno_uvjetovani_otkaz_tehnoloski } from '../contracts/9_poslovno_uvjetovani_otkaz_tehnoloski';
import { poslovno_uvjetovani_otkaz_tehnoloski_1 } from '../contracts/9.1_poslovno_uvjetovani_otkaz_tehnoloski.1';
import { poslovno_uvjetovani_otkaz_organizacijski } from '../contracts/10_poslovno_uvjetovani_otkaz_organizacijski';
import { poslovno_uvjetovani_otkaz_organizacijski_1 } from '../contracts/10.1_poslovno_uvjetovani_otkaz_organizacijski.1';
import { otkaz_ugovora_o_radu_osobno } from '../contracts/11_otkaz_ugovora_o_radu_osobno';
import { otkaz_ugovora_o_radu_osobno_1 } from '../contracts/11.1_otkaz_ugovora_o_radu_osobno.1';
import { opomena_pred_otkaz } from '../contracts/12_opomena_pred_otkaz';
import { opomena_pred_otkaz_1 } from '../contracts/12.1_opomena_pred_otkaz.1';
import { otkaz_ugovora_o_radu_skrivljeno_ponasanje } from '../contracts/13_otkaz_ugovora_o_radu_skrivljeno_ponasanje';
import { otkaz_ugovora_o_radu_skrivljeno_ponasanje_1 } from '../contracts/13.1_otkaz_ugovora_o_radu_skrivljeno_ponasanje.1';
import { otkaz_ugovora_novi_ugovor } from '../contracts/14_otkaz_ugovora_novi_ugovor';
import { otkaz_ugovora_novi_ugovor_1 } from '../contracts/14.1_otkaz_ugovora_novi_ugovor.1';
import { otkaz_ugovora_nezadovoljenje_na_probnom_radu } from '../contracts/15_otkaz_ugovora_nezadovoljenje_na_probnom_radu';
import { otkaz_ugovora_nezadovoljenje_na_probnom_radu_1 } from '../contracts/15.1_otkaz_ugovora_nezadovoljenje_na_probnom_radu.1';
import { otkaz_ugovora_o_radu_izvanredni } from '../contracts/16_otkaz_ugovora_o_radu_izvanredni';
import { otkaz_ugovora_o_radu_izvanredni_1 } from '../contracts/16.1_otkaz_ugovora_o_radu_izvanredni.1';
import { raskid_ugovora_o_radu_sporazum } from '../contracts/17_raskid_ugovora_o_radu_sporazum';
import { raskid_ugovora_o_radu_sporazum_1 } from '../contracts/17.1_raskid_ugovora_o_radu_sporazum.1';
import { izjava_o_odricanju_od_otkaznog_roka } from '../contracts/18_izjava_o_odricanju_od_otkaznog_roka';
import { izjava_o_odricanju_od_otkaznog_roka_1 } from '../contracts/18.1_izjava_o_odricanju_od_otkaznog_roka.1';

import { cesija_redovita } from '../contracts/19_cesija_redovita';
import { cesija_umjesto_placanja } from '../contracts/20_cesija_umjesto_placanja';
import { cesija_radi_ispunjenja } from '../contracts/21_cesija_radi_ispunjenja';
import { cesija_radi_osiguranja } from '../contracts/22_cesija_radi_osiguranja';
import { ugovor_o_preuzimanju_duga } from '../contracts/23_ugovor_o_preuzimanju_duga';
import { ugovor_o_pristupanju_dugu } from '../contracts/24_ugovor_o_pristupanju_dugu';
import { ugovor_o_preuzimanju_ispunjenja } from '../contracts/25_ugovor_o_preuzimanju_ispunjenja';
import { ugovor_o_asignaciji } from '../contracts/26_ugovor_o_asignaciji';
import { ugovor_o_kupoprodaji } from '../contracts/43_ugovor_o_kupoprodaji';
import { ugovor_o_djelu } from '../contracts/44_ugovor_o_djelu';
import { ugovor_o_autorskom_djelu } from '../contracts/45_ugovor_o_autorskom_djelu';
import { ugovor_o_zajmu_zajmodavac_fizicka_osoba } from '../contracts/46_ugovor_o_zajmu_zajmodavac_fizicka_osoba';
import { ugovor_o_zajmu_zajmoprimac_fizicka_osoba } from '../contracts/47_ugovor_o_zajmu_zajmoprimac_fizicka_osoba';
import { ugovor_o_zajmu_izmedu_povezanih_nepovezanih_osoba } from '../contracts/48_ugovor_o_zajmu_izmedu_povezanih_nepovezanih_osoba';
import { ugovor_o_poslovnoj_suradnji } from '../contracts/53_ugovor_o_poslovnoj suradnji';
import { ugovor_o_kompenzaciji } from '../contracts/54_ugovor_o_kompenzaciji';
import { ugovor_o_najmu } from '../contracts/49.1_ugovor_o_najmu';
import { ugovor_o_zakupu } from '../contracts/49.2_ugovor_o_zakupu';
import { ugovor_o_donaciji } from '../contracts/49.3_ugovor_o_donaciji';
import { ugovor_o_sponzorstvu } from '../contracts/49.4_ugovor_o_sponzorstvu';
import { ugovor_o_prijenosu_ugovora } from '../contracts/49.5_ugovor_o_prijenosu_ugovora';
import { ugovor_o_izvodenju_radova } from '../contracts/55_ugovor_o_izvodenju_radova';
// import { ugovor_o_gradenju } from '../contracts/56_ugovor_o_gradenju';
import { ugovor_o_GDPR_izvrsitelj } from '../contracts/91_ugovor_o_GDPR_izvrsitelj';

import { ugovor_o_posredovanju} from '../contracts/200_ugovor_o_posredovanju';
import { ugovor_o_povjerljivosti} from '../contracts/202_ugovor_o_povjerljivosti';
import { ugovor_o_povjerljivosti2} from '../contracts/202.1_ugovor_o_povjerljivosti2';
import { ugovor_o_uskladištenju} from '../contracts/203_ugovor_o_uskladištenju';
import { ugovor_o_ostavi} from '../contracts/204_ugovor_o_ostavi';
import { ugovor_o_komisiji } from '../contracts/212_ugovor_o_komisiji';
import { ugovor_o_kup_engl } from '../contracts/213_ugovor_o_kup_engl';
import { ugovor_o_stipendiranju } from '../contracts/211_ugovor_o_stipendiranju';
import { ugovor_o_stipendiranju_ucenika } from '../contracts/210_ugovor_o_stipendiranju_ucenika';
import { non_disclosure_agreement } from '../contracts/214_non_disclosure_agreement';
import { independant_contractor_agreeement } from '../contracts/215_independant_contractor_agreement';
import { nagodba } from '../contracts/232_nagodba';
import { ugovor_o_obrazovanju_radnika} from '../contracts/211.1_ugovor_o_obrazovanju';
import { pravilnik_zvizdaci} from '../contracts/220.1_pravilnik_zvizdaci';


// dummy contracts
import { odluka_o_isplati_dara_djetetu_do_15_godina_starosti } from '../contracts/37_odluka_o_isplati_dara_djetetu_do_15_godina_starosti';
import { odluka_prigodna_nagrada_bozicnica_uskrsnica_regres } from '../contracts/38_odluka_prigodna_nagrada_bozicnica_uskrsnica_regres';
import { odluka_potpora_za_novorodeno_dijete } from '../contracts/39_odluka_potpora_za_novorodeno_dijete';
import { odluka_potpora_za_smrt_clana_uze_obitelji_radnika } from '../contracts/40_odluka_potpora_za_smrt_clana_uze_obitelji_radnika';
import { odluka_prigodna_nagrada_za_godine_staza } from '../contracts/41_odluka_prigodna_nagrada_za_godine_staza';
import { odluka_naknada_troskova_prijevoza_na_posao_i_s_posla } from '../contracts/42_odluka_naknada_troskova_prijevoza_na_posao_i_s_posla';
import { odluka_o_rasporedu_radnog_vremena } from '../contracts/27_odluka_o_rasporedu_radnog_vremena';
import { odluka_o_rasporedu_koristenja_godisnjeg_odmora } from '../contracts/28_odluka_o_rasporedu_koristenja_godisnjeg_odmora';
import { odluka_o_placenom_dopustu } from '../contracts/29_odluka_o_placenom_dopustu';
import { odluka_o_neplacenom_dopustu } from '../contracts/31_olduka_o_neplacenom_dopustu';
import { odluka_o_koristenju_godisnjeg_odmora } from '../contracts/30_odluka_o_koristenju_godisnjeg_odmora';
import { odluka_o_radu_pod_nadzorom_zastita_na_radu } from '../contracts/101_odluka_o_radu_pod_nadzorom_zastita_na_radu';
import { potvrda_o_vrsti_i_trajanju_radnog_odnosa } from '../contracts/35_potvrda_o_vrsti_i_trajanju_radnog_odnosa';
import { potvrda_o_preuzimanju_radnopravne_dokumentacije } from '../contracts/36_potvrda_o_preuzimanju_radnopravne_dokumentacije';
import { izradi_vlastitu_odluku } from '../contracts/49_izradi_vlastitu_odluku';
import { izradi_vlastiti_ugovor } from '../contracts/50_izradi_vlastiti_ugovor';
// import { prijedlog_za_ovrhu_na_temelju_vjerodostojne_isprave } from '../contracts/51_prijedlog_za_ovrhu_na_temelju_vjerodostojne_isprave';
import { zahtjev_HZMO } from '../contracts/52.1_zahtjev_HZMO';
import { zahtjev_MUP } from '../contracts/52.2_zahtjev_MUP';
import { zahtjev_katastar } from '../contracts/52.3_zahtjev_katastar';
import { zahtjev_SKDD } from '../contracts/52.4_zahtjev_SKDD';
import { dopis_olaksica_prvo_zaposlenje } from '../contracts/69_dopis_olaksica_prvo_zaposlenje';
import { obavijest_nemogucnost } from '../contracts/70_obavijest_nemogucnost';
import { vracanje_osnove } from '../contracts/71_vracanje_osnove';
import { obavijest_sudu_o_prestanku_radnog_odnosa } from '../contracts/72_obavijest_sudu_o prestanku_radnog_odnosa';
import { obavijest_sudu_o_dost_novom } from '../contracts/72.1_obavijest_sudu_o_dost_novom';
import { proslj_isprave_novom } from '../contracts/73_proslj_isprave_novom';
import { obavijest_o_proslj_novom } from '../contracts/73.1_obavijest_o_proslj_novom';
import { vracanje_isprave_vjerovniku } from '../contracts/74_vracanje_isprave_vjerovniku';
import { obavijest_r_vijecu } from '../contracts/75_obavijest_r_vijecu';
import { savjetovanje_r_vijece } from '../contracts/76_savjetovanje_r_vijece';
import { zapisnik_o_predaji } from '../contracts/80_zapisnik_o_predaji';
import { zapisnik_povrat} from '../contracts/81_zapisnik_povrat';
import { zapisnik_pokretnine } from '../contracts/83_zapisnik_pokretnine';
import { zapisnik_pokretnine2 } from '../contracts/84_zapisnik_pokretnine2';
import { zapisnik_nekretnine} from '../contracts/85_zapisnik_nekretnine';
import { zapisnik_nekretnine2} from '../contracts/86_zapisnik_nekretnine2';
import { generalna_punomoc} from '../contracts/87_generalna_punomoc';
import { specijalna_punomoc} from '../contracts/88_specijalna_punomoc';
import { izradi_vlastiti_dopis} from '../contracts/50.1_izradi_vlastiti_dopis';
import { podsjetnik_placanje} from '../contracts/51.1_podsjetnik_placanje';
import { opomena_pred_tuzbu} from '../contracts/51.2_opomena_pred_tuzbu';
import { odluka_fiskalizacija} from '../contracts/111_odluka_fiskalizacija';
import { odluka_blag_maks } from '../contracts/112_odluka_blag_maks';
import { odluka_blag_min } from '../contracts/113_odluka_blag_min';
import { odluka_blag_likv } from '../contracts/114_odluka_blag_likv';
import { obavijest_ispitanicima} from '../contracts/90.2_obavijest_ispitanicima';
import { odluka_voditelj_obrade} from '../contracts/90.3_odluka_vod_obrade';
import { odluka_DPO} from '../contracts/90.5_odluka_DPO';
import { zahtjev_pristup_informacijama } from '../contracts/92_zahtjev_pristup_informacijama';
import { zahtjev_ispravak_dopuna } from '../contracts/93_zahtjev_ispravak_dopuna';
import { zahtjev_brisanje } from '../contracts/94_zahtjev_brisanje';
import { zahtjev_ogran} from '../contracts/94.1_zahtjev_ogran';
import { zahtjev_prijenos} from '../contracts/96_zahtjev_prijenos';
import { izjava_povj_voditelj } from '../contracts/90_izjava_povj_voditelj';
import { izjava_povj_izvrsitelj } from '../contracts/91.1_izjava_povj_izvrsitelj';
import { odluka_ovlast_ZNR } from '../contracts/102_odluka_ovlast_ZNR';
import { odluka_usvajanje_fin_izvj } from '../contracts/205_odluka_usvajanje_fin_izvj';
import { odluka_rasp_i_upotrebi_dobiti } from '../contracts/206_odluka_rasp_i_upotrebi_dobiti';
import { odluka_o_isplati_dobiti } from '../contracts/207_odluka_o_isplati_dobiti';
import { odluka_o_isplati_dobiti2 } from '../contracts/207.1_odluka_o_isplati_dobiti2';
import { odluka_inventura } from '../contracts/208_odluka_inventura';
import { izvjestaj_inventura } from '../contracts/209_izvjestaj_inventura';
import { inventura_dopusteni_manjak } from '../contracts/209.1_inventura_dopusteni_manjak';
import { inventura_nedopusteni_manjak } from '../contracts/209.2_inventura_nedopusteni_manjak';
import { pravilnik_o_poslovnoj_tajni } from '../contracts/220_pravilnik_o_poslovnoj tajni';
import { pravilnik_o_org_rada } from '../contracts/221_pravilnik_o_org_rada';
import { pravilnik_o_radu } from '../contracts/222_pravilnik_o_radu';
import { ugovor_o_radu_direktora } from '../contracts/225_ugovor_o_radu_direktora';
import { menadzerski_ugovor_kao_radni_odnos } from '../contracts/224_menadzerski_ugovor_kao_radni_odnos';
import { menadzerski_ugovor_poseban_ugovor } from '../contracts/223_menadzerski_ugovor_poseban_ugovor';
import { odluka_nagrade } from '../contracts/38.1_odluka_nagrade';
import { odluka_zast_dost } from '../contracts/230_odluka_zast_dost';
import { odluka_nadzor_osobnih} from '../contracts/231_odluka_nadzor_osobnih';
import { odluka_zvizdaci} from '../contracts/230.1_odluka_zvizdaci';
import { odluka_udaljenje } from '../contracts/29.1_odluka_udaljenje';
import { zahtjev_prekovremeni } from '../contracts/29.2_zahtjev_prekovremeni';
import { opravdanje_prekovremeni } from '../contracts/29.3_opravdanje_prekovremeni';
import { ugovor_dopunski_rad } from '../contracts/5.2._ugovor_dopunski_rad';
import { ugovor_dopunski_rad_pravilnik } from '../contracts/5.3._ugovor_dopunski_rad_pravilnik';
import { potvrda_o_radnom_odnosu } from '../contracts/234_potvrda_o_radnom_odnosu';
import { suglasnost_dopunski } from '../contracts/233_suglasnost_dopunski';
import { suodlucivanje_r_vijece } from '../contracts/77_suodlucivanje_r_vijece';
import { izjava_nezaposlenje_pk } from '../contracts/240_izjava_nezaposlenje_pk';
import { izjava_prehrana } from '../contracts/236_izjava_prehrana';
import { odluka_smjestaj } from '../contracts/238_odluka_smjestaj';
import { izjava_nagrade_rezultati } from '../contracts/38.2_izjava_nagrade_rezultati';
import { izjava_smjestaj } from '../contracts/238.1._izjava_smjestaj';
import { obavijest_smjestaj } from '../contracts/238.2._obavijest_smjestaj';
import { odluka_vrtic } from '../contracts/239_odluka_vrtic';
import { izjava_vrtic } from '../contracts/239.1_izjava_vrtic';
import { obavijest_vrtic } from '../contracts/239.2_obavijest_vrtic';
import { odluka_mjesto_rada} from '../contracts/29.5_odluka_mjesto_rada';
import { odluka_neisk_GO} from '../contracts/29.6._odluka_neisk_GO';
import { odluka_upucivanje} from '../contracts/29.4_odluka_upucivanje';
import { odluka_amort_stopa} from '../contracts/207.2_odluka_amort_stopa';
import { odluka_promj_amort_stope} from '../contracts/207.3_odluka_promj_ amort_stope';
import { rashod_imovine } from '../contracts/209.3_rashod_imovine';
import { odluka_predstavnik_prekrsaj } from '../contracts/231.1._odluka_predstavnik_prekrsaj';
import { odluka_pokrice_gubitka } from '../contracts/206.1_odluka_pokrice_gubitka';


@Injectable()
export class ContractService {
  
  constructor() { }

  private contractTemplates = [
    ugovor_o_radu_neodredjeno_osnovno,
    ugovor_o_radu_neodredjeno_osnovno_1,
    ugovor_o_radu_neodredjeno_dodatno,
    ugovor_o_radu_neodredjeno_dodatno_1,
    ugovor_o_radu_odredjeno_osnovno,
    ugovor_o_radu_odredjeno_osnovno_1,
    ugovor_o_radu_odredjeno_dodatno,
    ugovor_o_radu_odredjeno_dodatno_1,
    ugovor_dopunski_rad,
    ugovor_dopunski_rad_pravilnik,
    aneks_ugovora_o_radu,
    aneks_ugovora_o_radu_1,
    
    ugovor_o_kupoprodaji,
    ugovor_o_poslovnoj_suradnji,
    ugovor_o_prijenosu_ugovora,
    cesija_redovita,
    cesija_umjesto_placanja,
    cesija_radi_ispunjenja,
    cesija_radi_osiguranja,
    ugovor_o_preuzimanju_duga,
    ugovor_o_pristupanju_dugu,
    ugovor_o_preuzimanju_ispunjenja,
    ugovor_o_asignaciji,
    ugovor_o_kompenzaciji,
    ugovor_o_najmu,
    ugovor_o_zakupu,
    ugovor_o_zajmu_zajmodavac_fizicka_osoba,
    ugovor_o_zajmu_zajmoprimac_fizicka_osoba,
    ugovor_o_zajmu_izmedu_povezanih_nepovezanih_osoba,
    ugovor_o_djelu,
    ugovor_o_autorskom_djelu,
    ugovor_o_donaciji,
    ugovor_o_sponzorstvu,
    izradi_vlastiti_ugovor,
    ugovor_o_GDPR_izvrsitelj,
    ugovor_o_posredovanju,
    ugovor_o_uskladištenju,
    ugovor_o_ostavi,
    ugovor_o_komisiji,
    ugovor_o_povjerljivosti,
    ugovor_o_povjerljivosti2,
    ugovor_o_izvodenju_radova,
    // ugovor_o_gradenju,
    ugovor_o_stipendiranju_ucenika,
    ugovor_o_stipendiranju,
    ugovor_o_obrazovanju_radnika,
    non_disclosure_agreement,
    independant_contractor_agreeement,
    ugovor_o_kup_engl,
    pravilnik_o_radu,
    pravilnik_o_org_rada,
    pravilnik_o_poslovnoj_tajni,
    ugovor_o_radu_direktora,
    menadzerski_ugovor_kao_radni_odnos,
    menadzerski_ugovor_poseban_ugovor, 
    nagodba,
    pravilnik_zvizdaci,
  
    // dummy contracts
    poslovno_uvjetovani_otkaz_gospodarski,
    poslovno_uvjetovani_otkaz_gospodarski_1,
    poslovno_uvjetovani_otkaz_tehnoloski,
    poslovno_uvjetovani_otkaz_tehnoloski_1,
    poslovno_uvjetovani_otkaz_organizacijski,
    poslovno_uvjetovani_otkaz_organizacijski_1,
    otkaz_ugovora_o_radu_osobno,
    otkaz_ugovora_o_radu_osobno_1,
    opomena_pred_otkaz,
    opomena_pred_otkaz_1,
    otkaz_ugovora_o_radu_skrivljeno_ponasanje,
    otkaz_ugovora_o_radu_skrivljeno_ponasanje_1,
    otkaz_ugovora_novi_ugovor,
    otkaz_ugovora_novi_ugovor_1,
    otkaz_ugovora_nezadovoljenje_na_probnom_radu,
    otkaz_ugovora_nezadovoljenje_na_probnom_radu_1,
    otkaz_ugovora_o_radu_izvanredni,
    otkaz_ugovora_o_radu_izvanredni_1,
    raskid_ugovora_o_radu_sporazum,
    raskid_ugovora_o_radu_sporazum_1,
    otkaz_ugovora_o_radu_na_zahtjev_radnika,
    otkaz_ugovora_o_radu_na_zahtjev_radnika_1,
    otkaz_ugovora_o_radu_na_zahtjev_radnika_bez_otkaznog_roka,
    otkaz_ugovora_o_radu_na_zahtjev_radnika_bez_otkaznog_roka_1,
    izjava_o_odricanju_od_otkaznog_roka,
    izjava_o_odricanju_od_otkaznog_roka_1,
    odluka_o_rasporedu_radnog_vremena,
    odluka_o_rasporedu_koristenja_godisnjeg_odmora,
    odluka_o_koristenju_godisnjeg_odmora,
    odluka_o_placenom_dopustu,
    odluka_o_neplacenom_dopustu,
    odluka_upucivanje,
    odluka_mjesto_rada,
    odluka_neisk_GO,
    odluka_o_radu_pod_nadzorom_zastita_na_radu,
    odluka_ovlast_ZNR,
    odluka_o_isplati_dara_djetetu_do_15_godina_starosti,
    odluka_prigodna_nagrada_bozicnica_uskrsnica_regres,
    odluka_potpora_za_novorodeno_dijete,
    odluka_potpora_za_smrt_clana_uze_obitelji_radnika,
    odluka_prigodna_nagrada_za_godine_staza,
    odluka_naknada_troskova_prijevoza_na_posao_i_s_posla,
    odluka_nagrade,
    izradi_vlastitu_odluku,
    podsjetnik_placanje,
    opomena_pred_tuzbu,
    // prijedlog_za_ovrhu_na_temelju_vjerodostojne_isprave,
    zahtjev_HZMO,
    zahtjev_MUP,
    zahtjev_katastar,
    zahtjev_SKDD,
    obavijest_nemogucnost,
    proslj_isprave_novom,
    obavijest_o_proslj_novom,
    vracanje_isprave_vjerovniku,
    vracanje_osnove,
    obavijest_sudu_o_dost_novom,
    obavijest_sudu_o_prestanku_radnog_odnosa,
    obavijest_r_vijecu,
    savjetovanje_r_vijece,
    suodlucivanje_r_vijece,
    dopis_olaksica_prvo_zaposlenje,
    odluka_predstavnik_prekrsaj,
    generalna_punomoc,
    specijalna_punomoc,
    zapisnik_o_predaji,
    zapisnik_povrat,
    zapisnik_pokretnine,
    zapisnik_pokretnine2,
    zapisnik_nekretnine,
    zapisnik_nekretnine2,
    izradi_vlastiti_dopis,
    izjava_povj_izvrsitelj,
    odluka_voditelj_obrade,
    izjava_povj_voditelj,
    odluka_DPO,
    obavijest_ispitanicima,
    zahtjev_pristup_informacijama,
    zahtjev_ispravak_dopuna,
    zahtjev_brisanje,
    zahtjev_ogran,
    zahtjev_prijenos,
    odluka_zast_dost,
    odluka_nadzor_osobnih,
    odluka_zvizdaci,
    odluka_udaljenje,
    zahtjev_prekovremeni,
    opravdanje_prekovremeni,
    suglasnost_dopunski,
    potvrda_o_vrsti_i_trajanju_radnog_odnosa,
    potvrda_o_preuzimanju_radnopravne_dokumentacije,
    potvrda_o_radnom_odnosu,
    izjava_nagrade_rezultati,
    izjava_prehrana,
    odluka_smjestaj,
    izjava_smjestaj,
    obavijest_smjestaj,
    odluka_vrtic,
    izjava_vrtic,
    obavijest_vrtic,
    odluka_fiskalizacija,
    odluka_blag_maks,
    odluka_blag_min,
    odluka_blag_likv,
    odluka_usvajanje_fin_izvj,
    odluka_rasp_i_upotrebi_dobiti,
    odluka_o_isplati_dobiti,
    odluka_o_isplati_dobiti2,
    odluka_pokrice_gubitka,
    odluka_inventura,
    izvjestaj_inventura,
    inventura_dopusteni_manjak,
    inventura_nedopusteni_manjak,
    odluka_amort_stopa,
    odluka_promj_amort_stope,
    rashod_imovine,
    izjava_nezaposlenje_pk,


  ];


  /**
   * Retrieves list of all available templates.
   */
  getTemplates = () => {
    return this.contractTemplates.map(t => {
        return { templateId: t.templateId, category: t.category, title: t.templateTitle, description: t.templateDescription, empty: t.sides === null };
     });
  }

  /**
   * Retrieves the template by id.
   * @param {Number} id
   */
  getTemplate = id => {
    return new Contract(JSON.stringify(this.contractTemplates.find(t => t.templateId === id)));
  }

  /**
   * Retrieves list of all contracts.
   */
  getContracts = () => {
    let contracts = JSON.parse(localStorage.getItem("contracts")) || [];
    contracts.sort(function(a,b) {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
    return contracts;
  }

  /**
   * Retrieves the contract by id.
   * @param {String} id
   */
  getContract = id => {
    return new Contract(JSON.stringify(this.getContracts().find(c => c.id === id)));
  }

  /**
   * Saves the contract.
   * @param {Contract} contract
   */
  saveContract = contract => {
    let contracts = this.getContracts();

    function sanitizeName (contract) {
      let helperName = contract.name.split('(')[0];
      helperName = helperName.split('');

      return contract.name
    }

    let numberOfContracts = contracts.filter(c => c.name.split('(')[0].trim().includes(contract.name.split('(')[0].trim())).length;
    // let pos = contracts.findIndex(c => c.id === contract.id);
    // if (pos != -1) {
    //   contracts[pos] = contract;
    // } else {
      if ( numberOfContracts > 0 ) {
        contract.name = `${contract.name.split('(')[0].trim()} (${numberOfContracts})`;
      } 
      contracts.push(contract);
    // }
    localStorage.setItem("contracts", JSON.stringify(contracts));
  }

  /**
   * Deletes the contract with id.
   * @param {String} id
   */
  deleteContract = id => {
    let contracts = this.getContracts();
    let pos = contracts.findIndex(c => c.id === id);
    if (pos != -1) {
      contracts.splice(pos, 1);
    }
    localStorage.setItem("contracts", JSON.stringify(contracts));
  }

}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/service/contract.service.ts